<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.message.elements.attachments.types.customerForm.action.title')"
    :info="customer.displayName"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.attach'), type: 'confirm', callback: handleConfirm, disabled: !valid },
    ]"
    :loading="loading"
    :portal="portal"
  >
    <div class="relative">
      <customer-form-select
        v-model="customerForm"
        :customer="customer"
      />
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import CustomerFormSelect from '@/components/customerForm/elements/Select.vue'

import { CustomerMessageAttachment, CustomerMessageAttachmentType } from '~/_api/models/customerMessage'

interface Props {
  portal?: string
  loading?: boolean
  customer: Record<string, any>
}

withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<{
  (e: 'confirm', attachments: any[]): void
}>()

const dialog = ref<any>()
const customerForm = ref<any>(null)

const valid = computed(() => !!customerForm.value)

const open = () => {
  customerForm.value = null
  dialog.value.open()
}

const handleConfirm = async () => {
  if (!customerForm.value) {
    return false
  }

  const attachment = new CustomerMessageAttachment({
    type: CustomerMessageAttachmentType.customerForm,
    id: customerForm.value.idCustomerForm,
    data: customerForm.value,
  })

  emit('confirm', [attachment])

  return true
}

defineExpose({ open })
</script>
